import React, { Component } from 'react';
import { connect } from 'react-redux';


import { mapStateToProps, LoginStateProps } from '../utils'
import { NuovaPersonaForm } from '../components'



class NuovaPersona_ extends Component<LoginStateProps> {


  render() {
    if (!this.props.login.logged_in) {
      return (
        <div className="container">
          <h1 className="page-header">Iscrizione allo stage</h1>
          <p>Per iscriverti, devi innanzitutto fare il login.</p>
        </div>
      )
    }

    return (
      <div className="container">
        <h1 className="page-header">Registrazione persona</h1>
        <NuovaPersonaForm />
      </div>
    )
  }
}



const NuovaPersona = connect(mapStateToProps)(NuovaPersona_);
export default NuovaPersona;
